import { branch, renderComponent } from "recompose";

export const renderWhileLoading = (Component: any, propName = "data") =>
  branch(
    props => props[propName] && props[propName].loading,
    renderComponent(Component)
  );



// WEBPACK FOOTER //
// ./src/util/renderWhileLoading.ts